// extracted by mini-css-extract-plugin
export default {"root":"gw6A9aIiWSm2zRChprdd"};